import { createFileRoute } from "@tanstack/react-router";

import { OnboardingBrand } from "../../../features/onboarding/OnboardingBrand";

export const Route = createFileRoute("/_app/onboarding/brand")({
  component: OnboardingBrand,
});
